import React from 'react';
import { IShareStudyDialog } from './_types';
import ShareStudyForm from './ShareStudyForm';
import OverflowedDialog from 'components/Dialog/OverflowedDialog';
import { stateIsSame } from 'utils/componentOptimizatons';

const PlainShareStudyDialog: React.FC<IShareStudyDialog> = ({
  shareStudyDialog,
  setShareStudyDialog,
  studies,
}) => {
  const handleCloseShareStudyDialogDialog = () => setShareStudyDialog(false);

  return (
    <OverflowedDialog
      open={shareStudyDialog}
      onClose={handleCloseShareStudyDialogDialog}
      aria-labelledby="form-dialog-title"
      maxWidth="md"
      fullWidth={true}
      withScrolling={false}
    >
      <ShareStudyForm toggleDialog={handleCloseShareStudyDialogDialog} study={studies[0]} />
    </OverflowedDialog>
  );
};

export const ShareStudyDialog = React.memo(PlainShareStudyDialog, stateIsSame);
